import HomeView from '@/views/app/home/home.view'
import DefaultGuards from '@/guards/default.guards'
import confirmAccount from '@/components/auth/auth-confirm-account.vue'
import multiguard from 'vue-router-multiguard'
export default [{

  path: '',
  name: 'Home',
  component: HomeView,
  meta: {
    breadcrumb: 'Home',
    title: 'Bienvenido',
    top: 75,
    position: 'absolute',
    height: 40,
    hidden: 'block'

  },
  beforeEnter: multiguard([
    DefaultGuards.onQuery('presentations', {with: 'event'}),
    DefaultGuards.onQuery('categories', {limit: 1000})
    // DefaultGuards.onQuery('artistCategories', {limit: 1000}),
    // DefaultGuards.onQuery('eventCategories', {limit: 1000}),
    // DefaultGuards.onQuery('presentations'),
    // DefaultGuards.onQuery('venues', {limit: 1000})
  ]),
  children: [
    {
      path: 'register',
      name: 'register'
    },
    {
      path: 'sign-in',
      name: 'sign-in'
    },
    {
      component: confirmAccount,
      path: 'confirm-account/:token',
      name: 'confirm-account'
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/router/routes/app/home/home.route.js